import React, { useContext } from "react";
import environment from "../../../../../../../../RelayEnvironment";
import { QueryRenderer } from "react-relay";
import { graphql } from "graphql";
import { GreenMachineContext } from "../../../../GreenMachineContext";
import PlayerTableRow from "../../../../PlayerTable/PlayerTableRow";

const GET_PLAYERS = graphql`
  query LineupEditorPlayerSelectQuery(
    $slateID: ID!
    $rosterSlotID: ID!
    $salaryMax: Int!
  ) {
    playersForSlate(
      slateId: $slateID
      rosterSlotId: $rosterSlotID
      salaryMax: $salaryMax
    ) {
      id
      player {
        id
        name
        shortenedName
        team {
          abbreviation
          name
        }
      }
      position
      fppg
      salary
      rosterSlots {
        edges {
          node {
            name
          }
        }
      }
      slateCompetition {
        prettyStartTime
      }
      gupPercProj
    }
  }
`;

export default function LineupEditorPlayerSelect(componentProps) {
  const { selectedSlateID } = useContext(GreenMachineContext);

  function selectPlayer(player, state, salary) {
    componentProps.updateLineup(componentProps.index, player);
  }

  return (
    <QueryRenderer
      environment={environment}
      query={GET_PLAYERS}
      variables={{
        slateID: selectedSlateID,
        rosterSlotID: componentProps.rosterSlotId,
        salaryMax: componentProps.remainingSalary,
      }}
      render={({ error, props }) => {
        if (!props) {
          return <p>Loading Players...</p>;
        }

        return (
          <div style={{ width: "100%" }}>
            {props.playersForSlate.map((player) => {
              return (
                <PlayerTableRow
                  key={player.id}
                  player={player}
                  updateUnsavedSelections={selectPlayer}
                  selectedPlayers={[]}
                  sessionSelected={[]}
                />
              );
            })}
            <button
              onClick={(e) => {
                e.preventDefault();
                componentProps.cancel();
              }}
            >
              Cancel
            </button>
          </div>
        );
      }}
    />
  );
}
